export default __webpack_public_path__ + "static/media/mobile.f14c4758.svg";